import { ROUTES } from '@/configs/routes';

export const DOCUMENT_LINK_PATTERN = /\[!document:([^:!\]]+)(?::([^!\]]+))?!\]/gi;

export const buildDocumentLinkUrl = (organizationId: string, documentId: string, page?: string) =>
  ROUTES.organization.documents.document.documentPreview.create(organizationId, documentId, page);

export const buildDocumentLinkLabel = (page?: string) => `Документ${page ? ` (стр. ${page})` : ''}`;

export const buildDocumentLinkAttributes = (documentId: string, page?: string) => ({
  'data-document-id': documentId,
  ...(page ? { 'data-document-page': page } : {}),
});

const buildAttributesString = (attributes: Record<string, string>) =>
  Object.entries(attributes)
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

export const buildDocumentLinkHtml = (organizationId: string, documentId: string, page?: string): string => {
  const href = buildDocumentLinkUrl(organizationId, documentId, page);
  const label = buildDocumentLinkLabel(page);
  const attributes = buildDocumentLinkAttributes(documentId, page);
  const attributesString = buildAttributesString(attributes);
  const attributesSuffix = attributesString ? ` ${attributesString}` : '';

  return `<a href="${href}" target="_blank" rel="noopener noreferrer"${attributesSuffix}>${label}</a>`;
};

export const replaceDocumentPlaceholdersWithLinks = (value: string, organizationId?: string): string => {
  if (!organizationId) {
    return value;
  }

  const matches = [...value.matchAll(DOCUMENT_LINK_PATTERN)];

  if (matches.length === 0) {
    return value;
  }

  let result = '';
  let lastIndex = 0;
  let lastWasLink = false;

  for (const match of matches) {
    const start = match.index ?? 0;

    if (start > lastIndex) {
      result += value.slice(lastIndex, start);
      lastWasLink = false;
    } else if (lastWasLink) {
      // Separate consecutive placeholders to avoid merged anchors.
      result += ' ';
    }

    const documentId = match[1];
    const page = match[2];

    result += buildDocumentLinkHtml(organizationId, documentId, page);
    lastIndex = start + match[0].length;
    lastWasLink = true;
  }

  if (lastIndex < value.length) {
    result += value.slice(lastIndex);
  }

  return result;
};
